import React, { useEffect, useContext, useState, useRef, useCallback } from "react";
import "./FormsList.less";
import { deleteFormStructure } from "../../../../services/restAPI/FormsV3";
import { FormBuilderContext } from "../FormBuilderContext";
import { Table } from "antd";
import InputActions from "../InputActions/InputActions";
import { useIntl } from "react-intl";
import { Button, Input, Message } from "../../../BP2Components";
import { Icon_Search } from "../../../BP2Components/Icons/icons";
import IntlMessages from "../../../../util/IntlMessages";
import CreateNewListModal from "../../ListBuilder/ListBuilderView/ListBuilderModals/CreateNewListModal";
import { reverseList } from "../../ListBuilder/ListBuilderScripts";

const FormsList = () => {
   const [search, setSearch] = useState("");
   const [searchedColumn, setSearchedColumn] = useState("");

   const [isOpen, setIsOpen] = useState(false);
   const [parentFormId, setParentFormId] = useState();

   const searchInputRefs = useRef({});

   const {
      setEditedForm,
      fetchForms,
      formItems,
      loadingForms,
      copyForm,
      setSelectedForm,
      editedForm,
      data,
   } = useContext(FormBuilderContext);

   const intl = useIntl();

   const startEdit = (id) => {
      setEditedForm(id);
   };

   const deleteForm = async (id) => {
      const result = await deleteFormStructure(id);
      if (result.status === 204) {
         Message.success(intl.formatMessage({ id: "forms.deleteSuccess" }));
         fetchForms();
         if (data.id === id || editedForm === id) setSelectedForm(null);
      }
   };

   useEffect(() => {
      fetchForms();
   }, []);

   const handleCreateNewList = useCallback((item) => {
      setParentFormId(item);
      setIsOpen(true);
   }, []);

   const formListData = (formItems ?? []).map((item, idx) => ({
      lp: idx + 1,
      id: item.id,
      name: item.name,
      actions: (
         <div style={{ position: "relative" }}>
            <InputActions
               onStartEdit={() => startEdit(item.id)}
               onDuplicate={() => copyForm(item.id)}
               onDelete={() => deleteForm(item.id)}
               onNewListCreate={() => handleCreateNewList(item?.id)}
               show
            />
         </div>
      ),
   }));

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearch(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = (clearFilters) => {
      clearFilters();
      setSearch("");
   };

   const getColumnSearchProps = (dataIndex) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={(el) => {
                  searchInputRefs.current[dataIndex] = el;
               }}
               placeholder={intl.formatMessage({ id: "filter.search" })}
               value={selectedKeys[0]}
               onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Button
               buttonType="primary"
               onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
               icon="search"
               size="small"
               style={{ width: 90, marginRight: 8 }}
            >
               <IntlMessages id="filter.search" />
            </Button>
            <Button
               buttonType="primary"
               onClick={() => handleReset(clearFilters)}
               size="small"
               style={{ width: 90 }}
            >
               <IntlMessages id="filter.reset" />
            </Button>
         </div>
      ),
      filterIcon: () => (
         <i>
            <Icon_Search fill="none" stroke="#64748B" />
         </i>
      ),
      onFilter: (value, record) =>
         record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()) ?? false,
      onFilterDropdownVisibleChange: (visible) => {
         if (visible) {
            setTimeout(() => {
               const ref = searchInputRefs.current[dataIndex];
               ref?.select?.();
            }, 0);
         }
      },
      render: (text) => text,
   });

   const columns = [
      {
         title: intl.formatMessage({ id: "table.id" }),
         dataIndex: "id",
         ...getColumnSearchProps("id"),
      },
      {
         title: intl.formatMessage({ id: "table.name" }),
         dataIndex: "name",
         ...getColumnSearchProps("name"),
      },
      {
         title: intl.formatMessage({ id: "table.actions" }),
         dataIndex: "actions",
         className: "col-actions-fit",
      },
   ];

   return (
      <div style={{ padding: "20px", overflow: "scrol" }}>
         <h6>{intl.formatMessage({ id: "forms.forms_available" })}</h6>
         <Table
            bordered
            dataSource={reverseList(formListData)}
            columns={columns}
            pagination={true}
            tableLayout="auto"
            loading={loadingForms}
         />
         {parentFormId && (
            <CreateNewListModal parentFormId={parentFormId} isOpen={isOpen} setIsOpen={setIsOpen} />
         )}
      </div>
   );
};

export default FormsList;
